"use client";

import { IconAlertCircle } from "@tabler/icons-react";
import { useStore } from "@tanstack/react-store";
import type React from "react";
import { useEffect } from "react";
import { clearErrorToast, errorToastStore } from "../stores/error-toast";

export const ErrorToast: React.FC = () => {
  const {
    message,
    duration = 5000,
    icon = <IconAlertCircle className="size-6" />,
  } = useStore(errorToastStore) || {};

  useEffect(() => {
    if (!message || duration < 1) return;

    const timer = setTimeout(clearErrorToast, duration);
    return () => clearTimeout(timer);
  }, [message, duration]);

  if (!message) return null;

  return (
    <div
      className={`fixed bottom-18 md:bottom-24 left-1/2 transform -translate-x-1/2 bg-red-600 text-white text-sm w-max max-w-[90%] py-2 px-4 rounded-md shadow-lg z-[101] flex gap-2 transition-all duration-300 opacity-100 starting:opacity-0 translate-y-0 starting:translate-y-20 ${
        icon ? "items-start" : "items-center text-center text-balance"
      }`}
      onClick={() => clearErrorToast()}
    >
      {icon && <span className="flex-shrink-0 mt-1">{icon}</span>}
      <span>{message}</span>
    </div>
  );
};
